"use client";

import Link from "next/link";
import { trackPhoneClickConversion } from "@/components/utilities/googleAdsTracking";

interface CTA {
  label?: string;
  href?: string;
}

interface CtaLinkProps {
  cta: CTA;
  className: string;
  style?: React.CSSProperties;
}

export default function CtaLink({ cta, className, style }: CtaLinkProps) {
  if (!cta.href) return null;

  const handleClick = () => {
    if (cta.href?.startsWith("tel:")) {
      trackPhoneClickConversion();
    }
  };

  const isExternal = cta.href.startsWith("http");

  if (isExternal) {
    return (
      <a
        href={cta.href}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        style={style}
      >
        {cta.label}
      </a>
    );
  }

  return (
    <Link href={cta.href} onClick={handleClick} className={className} style={style}>
      {cta.label}
    </Link>
  );
}
